import type { CustomTone } from '@lyrmo/shared';
import { useCallback } from 'react';
import type { ApiClient } from '../../api/client';
import { useAccountList } from './useAccountList';

export interface CustomTones {
  /** Null until known: before the account loads, or while its tones do. */
  readonly tones: readonly CustomTone[] | null;
  /** Loads the tones again, as after one is made, changed, or deleted. */
  readonly reload: () => Promise<void>;
}

/**
 * The writer's custom tones, for the tone menu. `owner` is who's signed in: null for nobody,
 * who has none, and undefined until that's known. Tones are edited on the site, so they load
 * again whenever the window comes back to the front.
 */
export function useCustomTones(
  client: Pick<ApiClient, 'listCustomTones'>,
  owner: string | null | undefined,
): CustomTones {
  const load = useCallback(() => client.listCustomTones(), [client]);
  const { items, reload } = useAccountList(load, owner);
  return { tones: items, reload };
}
